"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMediaKeyError = exports.convertError = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
// https://developer.mozilla.org/en-US/docs/Web/API/MediaError/code#media_error_code_constants
// https://github.com/WebKit/WebKit/blob/2556a110ed4c9447ed726dca20c919660743d701/Source/WebCore/html/MediaError.h#L34-L44
const MediaErrorMap = {
    1: js_player_shared_1.ErrorTypes.ABORTED,
    2: js_player_shared_1.ErrorTypes.NETWORK,
    3: js_player_shared_1.ErrorTypes.DECODE,
    4: js_player_shared_1.ErrorTypes.SRC_NOT_SUPPORTED,
    5: js_player_shared_1.ErrorTypes.DRM,
};
const MediaKeyError = {
    1: "MEDIA_KEYERR_UNKNOWN",
    2: "MEDIA_KEYERR_CLIENT",
    3: "MEDIA_KEYERR_SERVICE",
    4: "MEDIA_KEYERR_OUTPUT",
    5: "MEDIA_KEYERR_HARDWARECHANGE",
    6: "MEDIA_KEYERR_DOMAIN",
};
const SystemCodeError = {
    1212433232: "UNSUPPORTED_SCREEN",
};
const convertError = (errorEvent) => {
    const { error } = errorEvent.target;
    const { code, message } = error || { code: -1, message: "" };
    return new js_player_shared_1.PlayerError(message, {
        type: MediaErrorMap[code] || js_player_shared_1.ErrorTypes.OTHER,
        code,
        rawError: error,
    });
};
exports.convertError = convertError;
const convertMediaKeyError = (keySession) => {
    const error = keySession.error || {};
    const errorCode = error.code;
    const systemCode = error.systemCode;
    const message = SystemCodeError[systemCode]
        ? SystemCodeError[systemCode]
        : MediaKeyError[errorCode];
    return new js_player_shared_1.PlayerError(`A decryption key error was encountered: ${message}`, {
        type: js_player_shared_1.ErrorTypes.DRM,
        code: systemCode || errorCode,
        rawError: keySession.error,
    });
};
exports.convertMediaKeyError = convertMediaKeyError;
//# sourceMappingURL=NativeErrors.js.map